import { IMonitor, IMonitorWithSecondlyNoiseConfig } from '../domain-models/Monitoring';

export const monitorHasSecondlyNoiseConfig = (monitor: IMonitor): monitor is IMonitorWithSecondlyNoiseConfig => {
  return monitor.omnisConfigJson?.configType === 'SECONDLY_NOISE';
};
